import React from 'react';
import { useHistory } from 'react-router-dom';
import { NavLink, Link } from 'react-router-dom';
import { Navbar, Nav } from 'react-bootstrap';
import { Roles, useAuthentication } from '../authentiction';
import { TileContainer, Tile } from '../tiles';
import Visitor from '../../images/Visitor.jpg';
import Reception from '../../images/Reception.jpg';
import Administrator from '../../images/Administrator.jpg';

const LandingPage: React.FC = () => {
  const { isAuthenticated, role, hasRole, onLogout } = useAuthentication();
  const history = useHistory();

  return (
    <div>
      <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
        <Navbar.Brand as={Link} to="/">
          Vis<sup>IT</sup>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ml-auto">
            {isAuthenticated && (
              <NavLink to="/" className="nav-link" onClick={onLogout}>
                Logout{isAuthenticated ? ` (${role})` : ''}
              </NavLink>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      <TileContainer>
        <Tile
          icon="user-visor"
          heading="Visitor"
          image={Visitor}
          content="Login using just a PIN and allow visitors to sign in and out"
          onClick={() =>
            history.push(
              isAuthenticated && hasRole(Roles.Visitor)
                ? '/visitor'
                : '/visitor/login',
            )
          }
        />
        <Tile
          icon="desktop"
          heading="Reception"
          image={Reception}
          content="Login to reception using a site PIN and password"
          onClick={() =>
            history.push(
              isAuthenticated && hasRole(Roles.Reception)
                ? '/reception'
                : '/reception/login',
            )
          }
        />
        <Tile
          icon="user-cog"
          heading="Administration"
          image={Administrator}
          content="Login as an administrator to maintain the list of sites"
          onClick={() =>
            history.push(
              isAuthenticated && hasRole(Roles.Admin)
                ? '/admin'
                : '/admin/login',
            )
          }
        />
      </TileContainer>
    </div>
  );
};

export default LandingPage;
